import useTranslation from 'hooks/useTranslation';
import styles from './styles.module.scss';

function Table({ tHeadItems, tbodyItems }) {
  const { getAppLocale } = useTranslation('ARCHIVE');
  const locale = getAppLocale();

  const handleClickTableRow = (id) => {
    if (id) {
      window.open(
        `/dashboard/conversations-archive/user/${id}`,
        '_blank',
        'noopener'
      );
    }
  };

  const renderCellContent = (cell) => {
    if (cell.content === '') return '-';

    // dates
    if (['firstOnline', 'lastOnline'].includes(cell.id)) {
      return cell.content?.[locale];
    }

    return cell.content;
  };

  const renderHeadItems = tHeadItems?.map((item) => (
    <th className={styles.table_head__item} key={item.id}>
      {item.content}
    </th>
  ));

  const renderTbodyItems = tbodyItems?.map((item) => (
    <tr
      onClick={() => handleClickTableRow(item.conversationId)}
      className={styles.table_body__row}
      key={item.id}
    >
      {item.value.map((cell) => (
        <td className={styles.table_body__item} key={cell.id}>
          {renderCellContent(cell)}
        </td>
      ))}
    </tr>
  ));

  return (
    <table className={styles.table}>
      <thead>
        <tr>{renderHeadItems}</tr>
      </thead>
      <tbody>{renderTbodyItems}</tbody>
    </table>
  );
}

export default Table;
